// Generated by Melange

import * as Buhta_identapis__Buhta_ident_control_v1_verifiable_type from "./buhta_ident_control_v1_verifiable_type.js";
import * as Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow from "./buhta_ident_identification_v1alpha1_ident_flow.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";
import * as Stdlib from "melange/stdlib.js";

const Imported$pmodules = {};

const LookupIdentFlowRequest = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1152,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const LookupIdentFlowResponse = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1215,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ProcessIdentFlowRequest = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1398,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "IdCardScanData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LivenessData"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "VerifiableData"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "IdentFlowAction"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ProcessIdentFlowResponse = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1864,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.ident.identification.v1alpha1.LookupIdentFlowRequest";
}

function make(codeOpt, expandOpt, param) {
  const code = codeOpt !== undefined ? codeOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          code: code,
          expand: expand
        };
}

const merge_code = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "code",
            "code"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            2,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          code: Curry._2(merge_code, t1.code, t2.code),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "code",
                    "code"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                      [
                        2,
                        "expand",
                        "expand"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      Ocaml_protoc_plugin__Spec.not_packed
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.code, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(code, expand) {
  return {
          code: code,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.LookupIdentFlowRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.code, param.expand);
  };
}

function constructor$1(code, expand) {
  return {
          code: code,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.LookupIdentFlowRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupIdentFlowRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.ident.identification.v1alpha1.LookupIdentFlowResponse";
}

function make$1(flow, param) {
  return {
          flow: flow
        };
}

const $$let = Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow.Buhta.Ident.Identification.V1alpha1.IdentFlow;

const merge_flow = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "flow",
            "flow"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          flow: Curry._2(merge_flow, t1.flow, t2.flow)
        };
}

function spec$1(param) {
  const $$let = Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow.Buhta.Ident.Identification.V1alpha1.IdentFlow;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "flow",
                    "flow"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.flow);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(flow) {
  return {
          flow: flow
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.LookupIdentFlowResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.flow);
  };
}

function constructor$3(flow) {
  return {
          flow: flow
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.LookupIdentFlowResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LookupIdentFlowResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

const IdentFlowAction = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1521,
      16
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "IdCardScanData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LivenessData"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "VerifiableData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const VerifiableData = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1612,
      18
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "IdCardScanData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LivenessData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const IdCardScanData = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1643,
      20
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const LivenessData = Caml_module.init_mod([
      "proto/identapis/gen/buhta_ident_identification_v1alpha1_ident_flow_service.ml",
      1703,
      20
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$2(param) {
  return ".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData.IdCardScanData";
}

function make$2(scan_session_tokenOpt, param) {
  const scan_session_token = scan_session_tokenOpt !== undefined ? scan_session_tokenOpt : "";
  return {
          scan_session_token: scan_session_token
        };
}

const merge_scan_session_token = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "scan_session_token",
            "scanSessionToken"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$2(t1, t2) {
  return {
          scan_session_token: Curry._2(merge_scan_session_token, t1.scan_session_token, t2.scan_session_token)
        };
}

function spec$2(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "scan_session_token",
                    "scanSessionToken"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._2(serialize$2, writer, param.scan_session_token);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(scan_session_token) {
  return {
          scan_session_token: scan_session_token
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData.IdCardScanData", spec$2(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.scan_session_token);
  };
}

function constructor$5(scan_session_token) {
  return {
          scan_session_token: scan_session_token
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData.IdCardScanData", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, IdCardScanData, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData.LivenessData";
}

function make$3(client_session_tokenOpt, param) {
  const client_session_token = client_session_tokenOpt !== undefined ? client_session_tokenOpt : "";
  return {
          client_session_token: client_session_token
        };
}

const merge_client_session_token = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "client_session_token",
            "clientSessionToken"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$3(t1, t2) {
  return {
          client_session_token: Curry._2(merge_client_session_token, t1.client_session_token, t2.client_session_token)
        };
}

function spec$3(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "client_session_token",
                    "clientSessionToken"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.client_session_token);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(client_session_token) {
  return {
          client_session_token: client_session_token
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData.LivenessData", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.client_session_token);
  };
}

function constructor$7(client_session_token) {
  return {
          client_session_token: client_session_token
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData.LivenessData", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, LivenessData, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData";
}

function make$4(verifiableOpt, param) {
  const verifiable = verifiableOpt !== undefined ? verifiableOpt : "not_set";
  return {
          verifiable: verifiable
        };
}

const merge_oneof_verifiable__Id_card_scan_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: IdCardScanData.name,
                make: IdCardScanData.make,
                from_proto: IdCardScanData.from_proto,
                from_proto_exn: IdCardScanData.from_proto_exn,
                to_proto: IdCardScanData.to_proto,
                to_proto$p: IdCardScanData.to_proto$p,
                merge: IdCardScanData.merge,
                to_json: IdCardScanData.to_json,
                from_json_exn: IdCardScanData.from_json_exn,
                from_json: IdCardScanData.from_json
              })
        ]));

const merge_oneof_verifiable__Liveness_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_req([
          [
            0,
            "",
            ""
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: LivenessData.name,
                make: LivenessData.make,
                from_proto: LivenessData.from_proto,
                from_proto_exn: LivenessData.from_proto_exn,
                to_proto: LivenessData.to_proto,
                to_proto$p: LivenessData.to_proto$p,
                merge: LivenessData.merge,
                to_json: LivenessData.to_json,
                from_json_exn: LivenessData.from_json_exn,
                from_json: LivenessData.from_json
              })
        ]));

function merge$4(t1, t2) {
  const match = t1.verifiable;
  const match$1 = t2.verifiable;
  let tmp;
  let exit = 0;
  if (typeof match === "string") {
    exit = 1;
  } else {
    const variant = match.NAME;
    if (variant === "Liveness_data") {
      if (typeof match$1 === "string" || match$1.NAME !== "Liveness_data") {
        exit = 1;
      } else {
        tmp = {
          NAME: "Liveness_data",
          VAL: Curry._2(merge_oneof_verifiable__Liveness_data, match.VAL, match$1.VAL)
        };
      }
    } else if (variant === "Id_card_scan_data" && !(typeof match$1 === "string" || match$1.NAME !== "Id_card_scan_data")) {
      tmp = {
        NAME: "Id_card_scan_data",
        VAL: Curry._2(merge_oneof_verifiable__Id_card_scan_data, match.VAL, match$1.VAL)
      };
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    tmp = match$1 === "not_set" ? match : match$1;
  }
  return {
          verifiable: tmp
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.oneof([
                  {
                    hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                          [
                            1,
                            "id_card_scan_data",
                            "idCardScanData"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: IdCardScanData.name,
                                make: IdCardScanData.make,
                                from_proto: IdCardScanData.from_proto,
                                from_proto_exn: IdCardScanData.from_proto_exn,
                                to_proto: IdCardScanData.to_proto,
                                to_proto$p: IdCardScanData.to_proto$p,
                                merge: IdCardScanData.merge,
                                to_json: IdCardScanData.to_json,
                                from_json_exn: IdCardScanData.from_json_exn,
                                from_json: IdCardScanData.from_json
                              }),
                          [
                            (function (v) {
                                return {
                                        NAME: "Id_card_scan_data",
                                        VAL: v
                                      };
                              }),
                            (function (param) {
                                if (typeof param === "string") {
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                }
                                if (param.NAME === "Id_card_scan_data") {
                                  return param.VAL;
                                }
                                throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                          MEL_EXN_ID: Stdlib.Invalid_argument,
                                          _1: "Cannot destruct given oneof"
                                        });
                              })
                          ]
                        ]),
                    tl: {
                      hd: Ocaml_protoc_plugin__Spec.oneof_elem([
                            [
                              2,
                              "liveness_data",
                              "livenessData"
                            ],
                            Ocaml_protoc_plugin__Spec.message({
                                  name: LivenessData.name,
                                  make: LivenessData.make,
                                  from_proto: LivenessData.from_proto,
                                  from_proto_exn: LivenessData.from_proto_exn,
                                  to_proto: LivenessData.to_proto,
                                  to_proto$p: LivenessData.to_proto$p,
                                  merge: LivenessData.merge,
                                  to_json: LivenessData.to_json,
                                  from_json_exn: LivenessData.from_json_exn,
                                  from_json: LivenessData.from_json
                                }),
                            [
                              (function (v) {
                                  return {
                                          NAME: "Liveness_data",
                                          VAL: v
                                        };
                                }),
                              (function (param) {
                                  if (typeof param === "string") {
                                    throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                              MEL_EXN_ID: Stdlib.Invalid_argument,
                                              _1: "Cannot destruct given oneof"
                                            });
                                  }
                                  if (param.NAME === "Liveness_data") {
                                    return param.VAL;
                                  }
                                  throw new Caml_js_exceptions.MelangeError(Stdlib.Invalid_argument, {
                                            MEL_EXN_ID: Stdlib.Invalid_argument,
                                            _1: "Cannot destruct given oneof"
                                          });
                                })
                            ]
                          ]),
                      tl: /* [] */0
                    }
                  },
                  (function (param) {
                      if (typeof param === "string") {
                        return Stdlib.failwith("Impossible case");
                      } else if (param.NAME === "Id_card_scan_data") {
                        return 0;
                      } else {
                        return 1;
                      }
                    })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.verifiable);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(verifiable) {
  return {
          verifiable: verifiable
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.verifiable);
  };
}

function constructor$9(verifiable) {
  return {
          verifiable: verifiable
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction.VerifiableData", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "IdCardScanData"
        ],
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "LivenessData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, VerifiableData, {
      IdCardScanData: IdCardScanData,
      LivenessData: LivenessData,
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction";
}

function make$5(idOpt, type$pOpt, data, param) {
  const id = idOpt !== undefined ? idOpt : "";
  const type$p = type$pOpt !== undefined ? type$pOpt : Curry._1(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType.from_int_exn, 0);
  return {
          id: id,
          "type'": type$p,
          data: data
        };
}

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_type$p = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "type",
            "type"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType),
          Curry._1(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType.from_int_exn, 0)
        ]));

const merge_data = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            3,
            "data",
            "data"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: VerifiableData.name,
                make: VerifiableData.make,
                from_proto: VerifiableData.from_proto,
                from_proto_exn: VerifiableData.from_proto_exn,
                to_proto: VerifiableData.to_proto,
                to_proto$p: VerifiableData.to_proto$p,
                merge: VerifiableData.merge,
                to_json: VerifiableData.to_json,
                from_json_exn: VerifiableData.from_json_exn,
                from_json: VerifiableData.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          id: Curry._2(merge_id, t1.id, t2.id),
          "type'": Curry._2(merge_type$p, t1["type'"], t2["type'"]),
          data: Curry._2(merge_data, t1.data, t2.data)
        };
}

function spec$5(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "id",
                    "id"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "type",
                        "type"
                      ],
                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType),
                      Curry._1(Buhta_identapis__Buhta_ident_control_v1_verifiable_type.Buhta.Ident.Control.V1.VerifiableType.from_int_exn, 0)
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                          [
                            3,
                            "data",
                            "data"
                          ],
                          Ocaml_protoc_plugin__Spec.message({
                                name: VerifiableData.name,
                                make: VerifiableData.make,
                                from_proto: VerifiableData.from_proto,
                                from_proto_exn: VerifiableData.from_proto_exn,
                                to_proto: VerifiableData.to_proto,
                                to_proto$p: VerifiableData.to_proto$p,
                                merge: VerifiableData.merge,
                                to_json: VerifiableData.to_json,
                                from_json_exn: VerifiableData.from_json_exn,
                                from_json: VerifiableData.from_json
                              })
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._4(serialize$5, writer, param.id, param["type'"], param.data);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(id, type$p, data) {
  return {
          id: id,
          "type'": type$p,
          data: data
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction", spec$5(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.id, param["type'"], param.data);
  };
}

function constructor$11(id, type$p, data) {
  return {
          id: id,
          "type'": type$p,
          data: data
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest.IdentFlowAction", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "IdCardScanData"
              ],
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "LivenessData"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "VerifiableData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, IdentFlowAction, {
      VerifiableData: VerifiableData,
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

function name$6(param) {
  return ".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest";
}

function make$6(codeOpt, flow, param) {
  const code = codeOpt !== undefined ? codeOpt : "";
  return {
          code: code,
          flow: flow
        };
}

const merge_code$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "code",
            "code"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_flow$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "flow",
            "flow"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: IdentFlowAction.name,
                make: IdentFlowAction.make,
                from_proto: IdentFlowAction.from_proto,
                from_proto_exn: IdentFlowAction.from_proto_exn,
                to_proto: IdentFlowAction.to_proto,
                to_proto$p: IdentFlowAction.to_proto$p,
                merge: IdentFlowAction.merge,
                to_json: IdentFlowAction.to_json,
                from_json_exn: IdentFlowAction.from_json_exn,
                from_json: IdentFlowAction.from_json
              })
        ]));

function merge$6(t1, t2) {
  return {
          code: Curry._2(merge_code$1, t1.code, t2.code),
          flow: Curry._2(merge_flow$1, t1.flow, t2.flow)
        };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "code",
                    "code"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "flow",
                        "flow"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: IdentFlowAction.name,
                            make: IdentFlowAction.make,
                            from_proto: IdentFlowAction.from_proto,
                            from_proto_exn: IdentFlowAction.from_proto_exn,
                            to_proto: IdentFlowAction.to_proto,
                            to_proto$p: IdentFlowAction.to_proto$p,
                            merge: IdentFlowAction.merge,
                            to_json: IdentFlowAction.to_json,
                            from_json_exn: IdentFlowAction.from_json_exn,
                            from_json: IdentFlowAction.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._3(serialize$6, writer, param.code, param.flow);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(code, flow) {
  return {
          code: code,
          flow: flow
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest", spec$6(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.code, param.flow);
  };
}

function constructor$13(code, flow) {
  return {
          code: code,
          flow: flow
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowRequest", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                {
                  TAG: /* Module */0,
                  _0: [
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "IdCardScanData"
                    ],
                    [
                      {
                        TAG: /* Module */0,
                        _0: [
                          [
                            /* Function */0,
                            "make"
                          ],
                          [
                            /* Function */0,
                            "to_proto"
                          ],
                          [
                            /* Function */0,
                            "from_proto"
                          ],
                          [
                            /* Function */0,
                            "to_json"
                          ],
                          [
                            /* Function */0,
                            "from_json"
                          ],
                          [
                            /* Function */0,
                            "name"
                          ],
                          [
                            /* Function */0,
                            "merge"
                          ],
                          [
                            /* Function */0,
                            "to_proto$p"
                          ],
                          [
                            /* Function */0,
                            "from_proto_exn"
                          ],
                          [
                            /* Function */0,
                            "from_json_exn"
                          ]
                        ]
                      },
                      "LivenessData"
                    ],
                    [
                      /* Function */0,
                      "make"
                    ],
                    [
                      /* Function */0,
                      "to_proto"
                    ],
                    [
                      /* Function */0,
                      "from_proto"
                    ],
                    [
                      /* Function */0,
                      "to_json"
                    ],
                    [
                      /* Function */0,
                      "from_json"
                    ],
                    [
                      /* Function */0,
                      "name"
                    ],
                    [
                      /* Function */0,
                      "merge"
                    ],
                    [
                      /* Function */0,
                      "to_proto$p"
                    ],
                    [
                      /* Function */0,
                      "from_proto_exn"
                    ],
                    [
                      /* Function */0,
                      "from_json_exn"
                    ]
                  ]
                },
                "VerifiableData"
              ],
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "IdentFlowAction"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ProcessIdentFlowRequest, {
      IdentFlowAction: IdentFlowAction,
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.ident.identification.v1alpha1.ProcessIdentFlowResponse";
}

function make$7(flow, param) {
  return {
          flow: flow
        };
}

const $$let$1 = Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow.Buhta.Ident.Identification.V1alpha1.IdentFlow;

const merge_flow$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "flow",
            "flow"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          flow: Curry._2(merge_flow$2, t1.flow, t2.flow)
        };
}

function spec$7(param) {
  const $$let = Buhta_identapis__Buhta_ident_identification_v1alpha1_ident_flow.Buhta.Ident.Identification.V1alpha1.IdentFlow;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "flow",
                    "flow"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._2(serialize$7, writer, param.flow);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(flow) {
  return {
          flow: flow
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowResponse", spec$7(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.flow);
  };
}

function constructor$15(flow) {
  return {
          flow: flow
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.ident.identification.v1alpha1.ProcessIdentFlowResponse", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ProcessIdentFlowResponse, {
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

const lookupIdentFlow_0 = {
  name: LookupIdentFlowRequest.name,
  make: LookupIdentFlowRequest.make,
  from_proto: LookupIdentFlowRequest.from_proto,
  from_proto_exn: LookupIdentFlowRequest.from_proto_exn,
  to_proto: LookupIdentFlowRequest.to_proto,
  to_proto$p: LookupIdentFlowRequest.to_proto$p,
  merge: LookupIdentFlowRequest.merge,
  to_json: LookupIdentFlowRequest.to_json,
  from_json_exn: LookupIdentFlowRequest.from_json_exn,
  from_json: LookupIdentFlowRequest.from_json
};

const lookupIdentFlow_1 = {
  name: LookupIdentFlowResponse.name,
  make: LookupIdentFlowResponse.make,
  from_proto: LookupIdentFlowResponse.from_proto,
  from_proto_exn: LookupIdentFlowResponse.from_proto_exn,
  to_proto: LookupIdentFlowResponse.to_proto,
  to_proto$p: LookupIdentFlowResponse.to_proto$p,
  merge: LookupIdentFlowResponse.merge,
  to_json: LookupIdentFlowResponse.to_json,
  from_json_exn: LookupIdentFlowResponse.from_json_exn,
  from_json: LookupIdentFlowResponse.from_json
};

const lookupIdentFlow = [
  lookupIdentFlow_0,
  lookupIdentFlow_1
];

const processIdentFlow_0 = {
  name: ProcessIdentFlowRequest.name,
  make: ProcessIdentFlowRequest.make,
  from_proto: ProcessIdentFlowRequest.from_proto,
  from_proto_exn: ProcessIdentFlowRequest.from_proto_exn,
  to_proto: ProcessIdentFlowRequest.to_proto,
  to_proto$p: ProcessIdentFlowRequest.to_proto$p,
  merge: ProcessIdentFlowRequest.merge,
  to_json: ProcessIdentFlowRequest.to_json,
  from_json_exn: ProcessIdentFlowRequest.from_json_exn,
  from_json: ProcessIdentFlowRequest.from_json
};

const processIdentFlow_1 = {
  name: ProcessIdentFlowResponse.name,
  make: ProcessIdentFlowResponse.make,
  from_proto: ProcessIdentFlowResponse.from_proto,
  from_proto_exn: ProcessIdentFlowResponse.from_proto_exn,
  to_proto: ProcessIdentFlowResponse.to_proto,
  to_proto$p: ProcessIdentFlowResponse.to_proto$p,
  merge: ProcessIdentFlowResponse.merge,
  to_json: ProcessIdentFlowResponse.to_json,
  from_json_exn: ProcessIdentFlowResponse.from_json_exn,
  from_json: ProcessIdentFlowResponse.from_json
};

const processIdentFlow = [
  processIdentFlow_0,
  processIdentFlow_1
];

const V1alpha1_IdentFlowService = {
  LookupIdentFlow: {
    name: "/buhta.ident.identification.v1alpha1.IdentFlowService/LookupIdentFlow",
    package_name: "buhta.ident.identification.v1alpha1",
    service_name: "IdentFlowService",
    method_name: "LookupIdentFlow",
    $$Request: {
      name: LookupIdentFlowRequest.name,
      make: LookupIdentFlowRequest.make,
      from_proto: LookupIdentFlowRequest.from_proto,
      from_proto_exn: LookupIdentFlowRequest.from_proto_exn,
      to_proto: LookupIdentFlowRequest.to_proto,
      to_proto$p: LookupIdentFlowRequest.to_proto$p,
      merge: LookupIdentFlowRequest.merge,
      to_json: LookupIdentFlowRequest.to_json,
      from_json_exn: LookupIdentFlowRequest.from_json_exn,
      from_json: LookupIdentFlowRequest.from_json
    },
    $$Response: {
      name: LookupIdentFlowResponse.name,
      make: LookupIdentFlowResponse.make,
      from_proto: LookupIdentFlowResponse.from_proto,
      from_proto_exn: LookupIdentFlowResponse.from_proto_exn,
      to_proto: LookupIdentFlowResponse.to_proto,
      to_proto$p: LookupIdentFlowResponse.to_proto$p,
      merge: LookupIdentFlowResponse.merge,
      to_json: LookupIdentFlowResponse.to_json,
      from_json_exn: LookupIdentFlowResponse.from_json_exn,
      from_json: LookupIdentFlowResponse.from_json
    }
  },
  lookupIdentFlow: lookupIdentFlow,
  ProcessIdentFlow: {
    name: "/buhta.ident.identification.v1alpha1.IdentFlowService/ProcessIdentFlow",
    package_name: "buhta.ident.identification.v1alpha1",
    service_name: "IdentFlowService",
    method_name: "ProcessIdentFlow",
    $$Request: {
      name: ProcessIdentFlowRequest.name,
      make: ProcessIdentFlowRequest.make,
      from_proto: ProcessIdentFlowRequest.from_proto,
      from_proto_exn: ProcessIdentFlowRequest.from_proto_exn,
      to_proto: ProcessIdentFlowRequest.to_proto,
      to_proto$p: ProcessIdentFlowRequest.to_proto$p,
      merge: ProcessIdentFlowRequest.merge,
      to_json: ProcessIdentFlowRequest.to_json,
      from_json_exn: ProcessIdentFlowRequest.from_json_exn,
      from_json: ProcessIdentFlowRequest.from_json
    },
    $$Response: {
      name: ProcessIdentFlowResponse.name,
      make: ProcessIdentFlowResponse.make,
      from_proto: ProcessIdentFlowResponse.from_proto,
      from_proto_exn: ProcessIdentFlowResponse.from_proto_exn,
      to_proto: ProcessIdentFlowResponse.to_proto,
      to_proto$p: ProcessIdentFlowResponse.to_proto$p,
      merge: ProcessIdentFlowResponse.merge,
      to_json: ProcessIdentFlowResponse.to_json,
      from_json_exn: ProcessIdentFlowResponse.from_json_exn,
      from_json: ProcessIdentFlowResponse.from_json
    }
  },
  processIdentFlow: processIdentFlow
};

const V1alpha1 = {
  LookupIdentFlowRequest: LookupIdentFlowRequest,
  LookupIdentFlowResponse: LookupIdentFlowResponse,
  ProcessIdentFlowRequest: ProcessIdentFlowRequest,
  ProcessIdentFlowResponse: ProcessIdentFlowResponse,
  IdentFlowService: V1alpha1_IdentFlowService
};

const Identification = {
  V1alpha1: V1alpha1
};

const Ident = {
  Identification: Identification
};

const Buhta = {
  Ident: Ident
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* LookupIdentFlowRequest Not a pure module */
